import { UPDATE_HREFLANG } from '../constants/hreflang';

/**
 * Updates the hrefLang for a given set of facet parameters.
 *
 * @param {boolean} clicked
 * @return {Object} Action object with type and payload.
 *
 */
export function updateHrefLang(clicked) {
  return {
    type: UPDATE_HREFLANG,
    payload: {
      clicked,
    },
  };
}
